import React from 'react';
import { useField, useFormikContext } from 'formik';
import { Box } from '@mui/material';
import { usePlacesWidget } from 'react-google-autocomplete';
//
import FormikCountry from './FormikCountry';
import FormikField from './FormikField';

interface iFormikAutoAddress {
  region?: string;
  label?: string;
}

const FormikAutoAddress: React.FC<iFormikAutoAddress> = ({
  region = 'ca',
  label,
}) => {
  const [city, setCity] = React.useState('');
  const [province, setProvince] = React.useState('');
  const [postalCode, setPostalCode] = React.useState('');
  const [address, setAddress] = React.useState('');

  const { setFieldValue, values } = useFormikContext();
  const [field, meta] = useField('address');
  const { touched, error } = meta;
  const { onBlur, value } = field;

  const { ref: materialRef } = usePlacesWidget({
    apiKey: import.meta.env.VITE_GOOGLE_API_KEY,
    options: {
      componentRestrictions: { country: region },
      fields: ['address_components'],
      types: ['address'],
    },
    onPlaceSelected: (place) => {
      let address1 = '';
      let postcode = '';
      for (let component in place?.address_components) {
        let current_component = place.address_components[component];
        const componentType = current_component.types[0];
        switch (componentType) {
          case 'street_number': {
            address1 = `${current_component.long_name} ${address1}`;
            break;
          }

          case 'route': {
            address1 += current_component.long_name;
            break;
          }

          case 'postal_code': {
            postcode = `${current_component.long_name}${postcode}`;
            break;
          }

          case 'postal_code_suffix': {
            postcode = `${postcode}-${current_component.long_name}`;
            break;
          }

          case 'locality': {
            setCity(current_component.long_name);
            break;
          }

          case 'postal_town': {
            setCity(current_component.long_name);
            break;
          }

          case 'administrative_area_level_1': {
            setProvince(current_component.long_name);
            break;
          }
        }
      }
      setPostalCode(postcode);
      setAddress(address1);
    },
  });

  const handleAdrs = (value: string) => {
    setAddress(value);
  };

  React.useEffect(() => {
    // @ts-ignore
    setCity(values?.city);
    // @ts-ignore
    setAddress(values?.address);
    // @ts-ignore
    setPostalCode(values?.postal);
    // @ts-ignore
    setProvince(values?.province);
  }, []);

  React.useEffect(() => {
    address && setFieldValue('address', address);
    postalCode && setFieldValue('postal', postalCode);
    city && setFieldValue('city', city);
    province && setFieldValue('province', province);
  }, [address, postalCode, city, province]);

  return (
    <>
      <FormikCountry name="home" label={label} maxHeight={220} />

      <FormikField
        autoComplete="off"
        name="location"
        onChange={(event) => handleAdrs(event.target.value)}
        value={address}
        inputRef={materialRef}
        placeholder="Search for your address"
        error={touched && Boolean(error)}
        helperText={touched && error}
        // onBlur={onBlur('address')}
      />

      {/* <FormikField name="address" placeholder="Address line 1" /> */}

      {/* <FormikField name="address2" placeholder="Address line 2" /> */}

      {address && postalCode && (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <FormikField
            name="city"
            placeholder="City"
            error={false}
            helperText=""
          />

          <FormikField
            name="province"
            placeholder="Province"
            error={false}
            helperText=""
          />

          <FormikField
            name="postal"
            placeholder="Postal code"
            error={false}
            helperText=""
          />
        </Box>
      )}
    </>
  );
};

export default FormikAutoAddress;
